// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".base-spinner svg[data-v-07c55dab]{animation:v-spinner-data-v-07c55dab .75s linear infinite}.base-spinner svg path[data-v-07c55dab]{stroke:currentColor}@keyframes v-spinner-data-v-07c55dab{to{transform:rotate(1turn)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
